<template>
  <div>
    <b-row>
      <b-col lg="4" sm="6" cols="12" class="mb-4">
        <app-stat
          :stat="!employeeStateCountsLoading ? enrollmentPercentage : undefined"
          suffix="%"
          :description="$t('dashboard.headerStats.enrolledDescription')"
          :icon="['far', 'user']"
          background-color="core-5"
        />
      </b-col>
      <b-col lg="4" sm="6" cols="12" class="mb-4">
        <app-stat
          :stat="appVisits"
          :formatter="toInteger"
          :description="$t('dashboard.headerStats.appVisitsDescription')"
          :icon="['far', 'mobile-alt']"
          background-color="warning-lighten-30"
        />
      </b-col>
      <b-col lg="4" sm="6" cols="12" class="mb-4">
        <app-stat
          :stat="savings"
          :formatter="toInteger"
          :description="$t('dashboard.headerStats.savingsDescription', { potLabel: bankingInfo.save.potLabel })"
          :icon="['far', 'coins']"
          background-color="core-3"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script setup>
import { computed, onBeforeMount, ref } from 'vue';
import ApiClient from '@/ApiClient';
import { getBankingInfo } from '@/Banking';
import AppStat from '@/components/AppStat.vue';
import useEmployees from '@/state/composables/useEmployees';
import useDivisionSelection from '@/state/composables/useDivisionSelection';
import State from '@/state/State';
import { toInteger } from '@/utils/common';

const { divisionId } = useDivisionSelection();
const { enrollmentPercentage, employeeStateCountsLoading } = useEmployees();

const bankingInfo = getBankingInfo();

const appVisits = ref(undefined);
const savings = ref(undefined);

const userIsAdmin = computed(() => State?.state?.claims?.a);

onBeforeMount(async () => {
  await Promise.all([
    (async () =>
      (appVisits.value = userIsAdmin.value ? (await ApiClient.getAppVisits())?.[0]?.app_visits || 0 : 'NA'))(),
    (async () =>
      (savings.value =
        ((await ApiClient.getBuildMetrics('w2w', divisionId.value || null)) || [])?.results?.find(
          result => result.id === 'pots_opened',
        )?.calculated?.last || 0))(),
  ]);
});
</script>
